import { BudgetUtilizationStateTypes, BudgetUtilizationActionTypes } from "./BudgetUtilization.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BudgetUtilizationStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const BudgetUtilizationReducer = (
  state: BudgetUtilizationStateTypes = INITIAL_STATE,
  action: any
): BudgetUtilizationStateTypes => {
  switch (action.type) {
    case BudgetUtilizationActionTypes.FETCH_ALL_BUDGET_UTILIZATION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BudgetUtilizationActionTypes.FETCH_ALL_BUDGET_UTILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BudgetUtilizationActionTypes.FETCH_ALL_BUDGET_UTILIZATION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BudgetUtilizationActionTypes.FETCH_ALL_BUDGET_UTILIZATION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case BudgetUtilizationActionTypes.FETCH_ONE_BUDGET_UTILIZATION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case BudgetUtilizationActionTypes.FETCH_ONE_BUDGET_UTILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BudgetUtilizationActionTypes.FETCH_ONE_BUDGET_UTILIZATION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BudgetUtilizationActionTypes.FETCH_ONE_BUDGET_UTILIZATION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BudgetUtilizationReducer;
